import { HttpClient } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { VendorMemberService } from '../member-vendor.service'
import { environment } from '../../../../environments/environment'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { VendorMemberModel } from '../member-vendor.model'
import { VendorService } from '../../vendor/vendor.service'
import { VendorModel } from '../../vendor/vendor.model'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { AuthStateService } from '../../../auth-state.service'

@Component({
  selector: 'app-view-vendormembers',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-vendor-members.component.html',
  styleUrl: './view-vendor-members.component.css',
})
export class ViewVendorMembersComponent implements OnInit {
  isLoading: boolean = false
  vendormembersData: VendorMemberModel[] = []
  vendorsData: VendorModel[] = []
  filteredVendorMembersData: VendorMemberModel[] = [];
  selectedVendorId: number | string = "";
  permissions: string[]= [];


  constructor(
    private authStateService: AuthStateService,
    private vendormemberService: VendorMemberService,
    private vendorService: VendorService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.authStateService.permissions.subscribe((permList) =>{
      this.permissions = permList
    })

  }

  ngOnInit(): void {
    this.vendormemberService.getAllVendorMembers().subscribe({
      next: (data: any) => {
        this.vendormembersData = data
        this.filterVendorMembers()
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })

    this.vendorService.getAllVendors().subscribe({
      next: (data: any) => {
        this.vendorsData = data
        if(this.vendorsData.length > 0){
          this.filterVendorMembers()
        }
        
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  hasPermission(action: string): boolean {
    return this.permissions.includes(action)
  }

  viewVendorMember(vendormember: VendorMemberModel) {
    this.router.navigate(['/addVendorMember'], {
      queryParams: { mode: 'view', ...vendormember },
    })
  }

  updateVendorMember(vendormember: VendorMemberModel) {
    

    this.router.navigate(['/addVendorMember'], {
      queryParams: { mode: 'update', ...vendormember },
    })
  }

  deleteVendorMember(vendormember: VendorMemberModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this vendormember?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.vendormemberService.deleteVendorMember(vendormember).subscribe({
          next: () => {
            this.vendormembersData = this.vendormembersData.filter(
              (p) => p.id !== vendormember.id,
            )
            this.toastr.success('VendorMember Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }

  getVendorName(vendorId: number): string {
    const vendor = this.vendorsData.find(c => c.id === vendorId);
    return vendor ? vendor.vendorName : 'Unknown';
  }

  filterVendorMembers() {
    if (this.selectedVendorId) {
      this.filteredVendorMembersData = this.vendormembersData.filter(vendormember => vendormember.vendorId.toString() === this.selectedVendorId?.toString());
    } else {
      this.filteredVendorMembersData = this.vendormembersData;
    }
  }

}
